module.exports = __webpack_public_path__ + "media/images/emblems/Langnau_im_Emmental-coat_of_arms-7a170da2af8019e6e16aa0bbef14f49c.svg";